player.playerSettingsModule = {
    // Toggle pre select v uzivatelskych nastaveniach (jazyk, rateChange)
    userSettingsSelectToggle: function(elementID, forceClose) {
        try {
            if ($("#userSettings" + elementID + "Select").is(":visible") || forceClose) {
                $("#select" + elementID).removeClass("selected").find(".icon").removeClass().addClass("icon icon-arrow-down");
                $("#userSettings" + elementID + "Select").hide();
            } else {
                $(".select-menu").each(function(sm, selectMenu) {
                    $(selectMenu).hide();
                });
                $("#select" + elementID).addClass("selected").find(".icon").removeClass().addClass("icon icon-arrow-up");
                $("#userSettings" + elementID + "Select").show();
            }
            return true;
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na ulozenie user nastaveni do db cez nativeApp 
    setPlayerInfo: function() {
        try {
            SetPlayerInfo(
                stored.UserSettings.Modified.playerLanguage,
                stored.UserSettings.Modified.favoriteSportLeague,
                stored.UserSettings.Modified.favoriteEvent,
                stored.UserSettings.Modified.allowedRateChangePlayer,
                stored.UserSettings.Modified.notifySMS
            );
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia cisti player nastavenia
    clearUserSettings: function() {
        try {
            // Select buttony
            delete stored.UserSettings.Original;
            delete stored.UserSettings.Modified;
            delete stored.PlayerFavorite;
            if (offer.lang !== profile.LanguageIdDefault) {
                offer.lang = profile.LanguageIdDefault;
                ticket.ticketLang();
                shared.getGameParts();
                if (typeof SetPlayerLanguage === "function") {
                    SetPlayerLanguage(offer.lang, "clearUserSettings");
                } else {
                    main.requestTranslations(offer.lang);
                }
            }
            // Checkboxy
            player.playerSettingsModule.userSettingCheckboxTrigger("favoriteSportLeague", false, true);
            player.playerSettingsModule.userSettingCheckboxTrigger("favoriteEvent", false, true);
            player.playerSettingsModule.userSettingCheckboxTrigger("notifySMS", false, true);
            // Nastavenie default stavu pripisovania vyhry k zostatku pre quickbet
            stored.QuickBetSwitchBalanceAutoAdd = profile.QuickBets.BalanceAutoAdd;
            $("#quickBetSwitchBalanceAutoAdd").attr("checked", stored.QuickBetSwitchBalanceAutoAdd);
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na toggle checkboxu s checkboxID
    userSettingCheckboxTrigger: function(checkboxID, state, force) {
        try {
            var checkBoxElement = $("#" + checkboxID);
            if (force) {
                var checkBoxElement = $("#" + checkboxID);
                checkBoxElement.attr("checked", state);
                return state;
            } else {
                if ((checkBoxElement).attr("checked")) {
                    // Toggle checkbox
                    checkBoxElement.attr("checked", false);
                    return false;
                } else {
                    // Toggle checkbox
                    checkBoxElement.attr("checked", true);
                    return true;
                }
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Ulozenie nastaveni playera
    userSettingsPreserve: function(save, initiator) {
        try {
            if (!stored.PlayerID || stored.PlayerID === profile.ManualVerifiedPlayerID) {
                return false;
            }
            main.userAction();
            var userSettingChanged;
            userSettingChanged = Object.keys(stored.UserSettings.Original).some(function(userSetting) {
                if (stored.UserSettings.Original[userSetting] !== stored.UserSettings.Modified[userSetting]) {
                    return true;
                }
            });
            if (userSettingChanged) {
                if (initiator === "setBalance" || initiator === "changeLang" || initiator === "saveUserSettings") {
                    if (stored.UserSettings.Modified.playerLanguage !== stored.UserSettings.Original.playerLanguage !== offer.lang) {
                        offer.lang = stored.UserSettings.Modified.playerLanguage;
                        if (initiator !== "saveUserSettings") {
                            ticket.ticketLang();
                            shared.getGameParts();
                        }
                        if (typeof SetPlayerLanguage === "function") {
                            SetPlayerLanguage(offer.lang, "preserveUserSettings");
                        } else {
                            main.requestTranslations(offer.lang);
                        }
                    }
                }
                if ((stored.AllowedRateChange !== stored.UserSettings.Original.allowedRateChangePlayer) ||
                    (stored.UserSettings.Modified.allowedRateChangePlayer !== stored.UserSettings.Original.allowedRateChangePlayer)) {
                    ticket.allowedRateChange(stored.UserSettings.Modified.allowedRateChangePlayer);
                } else {
                    player.playerSettingsModule.modifyUserSettingsObject(stored.UserSettings.Modified.allowedRateChangePlayer, "noModify");
                }
                if (save && (initiator === "saveUserSettings" || initiator === "changeLang" || initiator === "preserveUserSettings")) {
                    // Poziadavka na ulozenie nastaveni a zavolanie na nativeApp
                    stored.UserSettings.Original = Object.assign({}, stored.UserSettings.Modified);
                    player.playerSettingsModule.setPlayerInfo();
                }
            } else if (initiator === "setBalance" && stored.UserSettings && stored.UserSettings.Original && stored.UserSettings.Original.playerLanguage) {
                offer.lang = stored.UserSettings.Original.playerLanguage;
                // Nastevenie zobrazenia sekcii "Herny plan" a DOXXbet klub
                more.menu.setProperties(profile.Terms, profile.GDPR, profile.Bonuses, profile.Club, profile.ClubHomeButton, profile.ClubNew, profile.ClubCompetition);
                // Zmena jazyka na tiketovej sluzbe
                ticket.ticketLang();
                // Vymaze ticketStatus a nanovo vytvori direktivu, vytvori elementy pre detail tiketu
                $("#ticketStatus #section").empty().append(ticketStatusSection).trigger("create");
                // Nastavy zvoleny jazyk
                main.setLabels(offer.lang);
                // Vymaze ticketStatus a nanovo vytvori direktivu
                delete T.ticketStatus;
                directives.ticketDetailDirective.ticketStatus();
                // Zmena jazyka na vrchnej obrazovke
                communication.topScreen('setLanguage', offer.lang);
                // Nastavi gameparty
                shared.getGameParts();
                // Nanovo vyrenderuje moje tikety, bez dopytovania novych dat
                player.playerTickets.myTicketsFilter(false, false);
                   // Prejde na domovsku obrazovku vykresli popularne ligy a nastavi ribbony na domovskej v dlazdiciach
                   if (cache) {
                    // Nastavi home obrazovku - popularne ligy
                    if (cache.EventsOfDay) {
                        delete cache.EventsOfDay;
                    }
                    if (cache.TopOfferLeagueCups) {
                        delete cache.TopOfferLeagueCups;
                    }
                }
                main.setPage(1);
                if ((profile.Club || profile.Bonuses) && profile.ClubHomeButton) {
                        if (profile.ClubNew || profile.ClubCompetition) {
                            $("#homeButtons .ui-block-b .home-new").removeClass().addClass("home-new new-" + offer.lang);
                        } else if (profile.LocalCompetition) {
                            $("#homeButtons .ui-block-b .home-new").removeClass().addClass("home-new new-" + offer.lang + " competition-" + profile.LocalCompetition.toLowerCase());
                        }
                    }
                }
            // Zatvorenie okna player nastaveni
            main.closeDialog(true);
            return true;
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Toggle pre select v uzivatelskych nastaveniach (jazyk, rateChange)
    playerBonusesSelectToggle: function(elementID, forceClose) {
        try {
            if ($("#bonuses" + elementID + "Select").is(":visible") || forceClose) {
                $("#select" + elementID).removeClass("selected");
                $("#bonuses" + elementID + "Select").hide();
            } else {
                $(".select-menu").each(function(sm, selectMenu) {
                    $(selectMenu).hide();
                });
                $("#select" + elementID).addClass("selected");
                $("#bonuses" + elementID + "Select").show();
            }
            return true;
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Zmena v uzivatelskych nastaveniach
    modifyUserSettingsObject: function(prop, propValue, initiator) {
        try {
            main.userAction();
            switch (prop) {
                case "playerLanguage":
                    $("#userSettingsLanguageList").find(".selected").removeClass("selected");
                    $("#selectLanguage .lang-img").removeClass().addClass("lang-img lang-" + propValue);
                    $("#selectLanguage #selectedLanguage").text(profile.AvailableLanguages.find(function (availableLang) { return (availableLang.code === propValue) })?.languageName);
                    // Zatvorenie selectu s moznostami
                    player.playerSettingsModule.userSettingsSelectToggle("Language", true);

                    if (typeof SetPlayerLanguage === "function") {
                        SetPlayerLanguage(propValue, initiator);
                    } else {
                        main.requestTranslations(propValue);
                    }
                    break;
                case "allowedRateChangePlayer":
                    // Zmena zobrazenia v selectboxe
                    $("#rateChangesButtons").find(".ui-radio-on").removeClass("ui-radio-on");
                    $("#rateChangesButtons").find("#acceptRate" + propValue + "Label").addClass("ui-radio-on");
                    // Zmena zobrazenia v user nastaveniach
                    $("#userSettingsRateChangeList").find(".selected").removeClass("selected");
                    $("#userSettingsRateChangeList #rateChangeItem" + propValue).addClass("selected");
                    $("#selectRateChange #selectedRateChange").text(texts["RateChangeAccept" + propValue]);
                    player.playerSettingsModule.userSettingsSelectToggle("RateChange", true);

                    // Bez modifikacie Objektu
                    if (initiator) return false;
                    break;
                case "favoriteSportLeague":
                case "favoriteEvent":
                case "notifySMS":
                    propValue = player.playerSettingsModule.userSettingCheckboxTrigger(prop);
                    break;
                default:
                    break;
            }
            if (stored.PlayerID && (stored.PlayerID !== profile.ManualVerifiedPlayerID)) {
                if (typeof propValue === "boolean") {
                    stored.UserSettings.Modified[prop] = (propValue === true)? "1": "0";
                } else {
                    stored.UserSettings.Modified[prop] = propValue;
                }
            }
            return true;
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
